import React from 'react';
import { Button } from '../components/ui/Button';
import { MessageCircle } from 'lucide-react';
export function ContactPage() {
  const handleWhatsApp = () => {
    window.open('https://wa.link/infocommerce', '_blank');
  };
  return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#FAFAFA] p-4" data-id="element-26">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-27">
        {/* Header Section */}
        <div className="p-8 sm:p-10 text-center space-y-8" data-id="element-28">
          <div className="space-y-3" data-id="element-29">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-30">
              ¿Tienes Preguntas?
            </h1>
            <p className="text-gray-500 text-lg" data-id="element-31">
              Estamos aquí para ayudarte a resolver cualquier duda sobre el
              programa.
            </p>
          </div>

          <div className="py-4 space-y-4" data-id="element-32">
            <Button onClick={handleWhatsApp} size="lg" className="w-full text-lg font-semibold h-16 !bg-[#25D366] hover:!bg-[#20bd5a] text-white shadow-md hover:shadow-lg transition-all duration-300 border-none" leftIcon={<MessageCircle className="w-6 h-6" data-id="element-34" />} data-id="element-33">
              Chatear por WhatsApp
            </Button>

            <p className="text-xs text-gray-400" data-id="element-35">
              Respuesta rápida garantizada
            </p>

            <div className="pt-2" data-id="element-36">
              
            </div>
          </div>
        </div>
      </div>

      {/* Footer minimal */}
      <div className="mt-8 text-center text-gray-400 text-sm" data-id="element-37">
        &copy; {new Date().getFullYear()} Info Commerce AI Bootcamp. Todos los
        derechos reservados.
      </div>
    </div>;
}